import Vue from 'vue'
import axios from 'axios'

var isRefreshing = false;
var failedQueue = [];

var processQueue = function(error, token) {
  token = token  || null
  for(var i = o; i < failedQueue.length; i++){
    var prom = failedQueue[i]
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  }
  
  failedQueue = [];
}

// let baseDomain = ''
// const metatag = document.querySelectorAll('meta[property="basedomain"]')
// if (metatag.length > 0) {
//   baseDomain = metatag[0].getAttribute('content')
// }

var options = {
  // base: window.location.origin.replace("www.", "api.").replace(":8080", "") + "/{api}",
  base: (window.baseDomain === '' ? '/' : 'https://api.' + window.baseDomain + '/') +  '{api}{name}',
  // base: "//" + process.env.VUE_APP_API + process.env.VUE_APP_DOMAIN + "/{api}",
  api: "general",
  auth: true,
  name: false
}

var http = {
  ajax: axios.create({
    withCredentials: true
  }),
  instance: axios
}


var refreshing = false;

http.ajax.interceptors.request.use(function(config){
  return new Promise(function(resolve, reject){
    var $auth = Vue.prototype.$auth
    var data = {
      api: config.api || options.api,
      auth: config.auth === false ? config.auth : options.auth,
      name: config.name ? "/" + config.name : ""
    }
    config.baseURL = options.base.replace(/\{ *([\w_-]+) *\}/g, function (match, key) {
      return data[key]
    })
    
    if(data.auth){
      if($auth.via_loggedin || refreshing){
        config.headers['Authorization'] = 'Bearer ' + $auth.via_local().get().Token
        resolve(config)
      }else{
        refreshing = true
        resolve($auth.via_refreshToken().then(function(resp){
          refreshing = false
          if(resp.status){
            config.headers['Authorization'] = 'Bearer ' + $auth.via_local().get().Token
            return config
          }else{
            return false
          }
        }))
      }
    }else{
      resolve(config)
    }

  }).then(function(options){
    if(options){
      return Promise.resolve(options)
    }else{
      return Promise.reject('Failed to login')
    }
  }).catch(function(error){
    return Promise.reject(error)
  })
});

http.ajax.interceptors.response.use(function(response){
  return response
}, function(error){
  var $auth = Vue.prototype.$auth
  const originalRequest = error.config;

  if(error.response){
    if ((error.response.status === 401) && !originalRequest._retry){// || error.response.status === 403) {
      if (isRefreshing) {
        return new Promise(function(resolve, reject) {
          failedQueue.push({resolve, reject})
        }).then(function(token) {
          originalRequest.headers['Authorization'] = 'Bearer ' + token;
          return http.instance(originalRequest);
        }).catch(function(err) {
          return Promise.reject(err);
        })
      }

      originalRequest._retry = true;
      isRefreshing = true;

      return $auth.via_refreshToken().then(function(data){
        if(data.status){
          processQueue(null, $auth.via_local().get().Token); //data.Token
          isRefreshing = false
          error.response.config.headers['Authorization'] = 'Bearer ' + $auth.via_local().get().Token;
          return http.instance(error.response.config);
        }else{
          processQueue(error, null);
          isRefreshing = false
          return Promise.reject(error)
        }
      })
    }else if(error.response.status === 403){
      //$auth.via_logout()
    }
  }
  return Promise.reject(error)
})

export default http